
import { toggleScroll } from "@/utilities/toggleScroll";


const header = document.getElementById( 'site-header' );
const mobileMenuToggle = document.getElementById( 'mobile-menu-toggle' );
const mobileMenu = document.getElementById( 'mobile-menu' );
const sideMenu = document.getElementById( 'side-menu' );
const sideMenuOpen = document.getElementById( 'side-menu-toggle' );
const sideMenuClose = document.getElementById( 'side-menu-close' );


mobileMenuToggle?.addEventListener( 'click', () => {
    toggleMenu( 'mobile' );
} );

mobileMenu?.querySelectorAll( 'a' ).forEach( link => {
    link.addEventListener( 'click', () => {
        closeMenus();
    } );
} );

sideMenuOpen?.addEventListener( 'click', () => {
    openMenu( 'side' );
} );

sideMenuClose?.addEventListener( 'click', () => {
    closeMenus();
} );


/**
 * @param {string} menu Then menus name
 *
 * @return void
 */
function toggleMenu( menu ) {
    if ( header?.getAttribute( 'data-menu-active' ) === menu ) {
        closeMenus();
    } else {
        openMenu( menu );
    }
}

/**
 * Opens the specified header menu
 *
 * @param {string} menu
 *
 * @return void
 */
function openMenu( menu ) {
    header?.setAttribute( 'data-menu-active', menu );
    toggleScroll( false );
}

/**
 * Closes all the header menus
 *
 * @return void
 */
function closeMenus() {
    header?.removeAttribute( 'data-menu-active' );
    toggleScroll( true );
}

/*
Using intersection observer is way more efficient than adding a scroll listener for this task
*/
const scrollIndicator = document.getElementById( 'site-header-scroll-indicator' );
if ( header && scrollIndicator ) {
    const scrollDeterminer = new IntersectionObserver( headerScrollHandler, {} );
    scrollDeterminer.observe( scrollIndicator );
}

/**
 * @param {IntersectionObserverEntry[]} entries
 *
 * @return void
 */
function headerScrollHandler( entries ) {
    entries.forEach( entry => {
        header?.toggleAttribute( 'data-scrolled', !entry.isIntersecting );
    } );
}


document.addEventListener( 'DOMContentLoaded', function() {
    const leftMenu = document.getElementById( 'left-menu' );
    const rightMenu = document.getElementById( 'right-menu' );
    const leftMenuContent = document.getElementById( 'left-menu-content' );
    const rightMenuContent = document.getElementById( 'right-menu-content' );
    const leftHeading = document.getElementById( 'left-heading' );
    const rightHeading = document.getElementById( 'right-heading' );

    if ( leftMenu && rightMenu && leftMenuContent && rightMenuContent && leftHeading && rightHeading ) {
        const transitionDuration = 300;

        const toggleNav = ( activeMenu, inactiveMenu, activeContent, inactiveContent ) => {
            inactiveContent.classList.add( 'fade-out' );
            activeContent.classList.add( 'fade-out' );

            setTimeout( () => {
                inactiveContent.classList.add( 'hidden' );
                activeContent.classList.add( 'hidden' );
                activeMenu.classList.add( 'active' );
                inactiveMenu.classList.remove( 'active' );

                setTimeout( () => {
                    activeContent.classList.remove( 'hidden', 'fade-out' );
                    activeContent.classList.add( 'fade-in' );
                }, transitionDuration );
            }, transitionDuration );

            sessionStorage.setItem( 'navPreference', activeMenu.id.includes( 'left' ) ? 'left' : 'right' );
        };

        const navPreference = sessionStorage.getItem( 'navPreference' );

        if ( navPreference === 'right' ) {
            toggleNav( rightMenu, leftMenu, rightMenuContent, leftMenuContent );
        } else {
            toggleNav( leftMenu, rightMenu, leftMenuContent, rightMenuContent );
        }

        leftHeading.addEventListener( 'click', () => toggleNav( leftMenu, rightMenu, leftMenuContent, rightMenuContent ) );
        rightHeading.addEventListener( 'click', () => toggleNav( rightMenu, leftMenu, rightMenuContent, leftMenuContent ) );
    }
} );
